import enviro from 'enviro';
export const ASK_AI_ACTION_TESTING_META = {
  id: {
    prod: '0-172351286',
    qa: '0-40944017'
  },
  aiGeneratedFields: ['response'],
  isTestingEnabled: true
};
export const CHAT_API_CALL_TESTING_META = {
  id: {
    prod: null,
    qa: '1-170456945'
  },
  isTestingEnabled: true
};
export const ALL_TESTING_META = [ASK_AI_ACTION_TESTING_META, CHAT_API_CALL_TESTING_META];
export const TestingMetaById = ALL_TESTING_META.reduce((acc, meta) => {
  const envId = enviro.isQa() ? meta.id.qa : meta.id.prod;
  if (envId) {
    acc[envId] = meta;
  }
  return acc;
}, {});